import React from 'react';
import background from '../../assets/zooplankton.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoZooplankton extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="OCEANS"
        description="Zooplankton"
        paragraph="Zooplankton play an important role in marine food webs, acting as carriers of energy from phytoplankton to higher trophic levels including fish, whales, crabs, shrimp, sea turtles and birds."
        background={background}
     />
  
  );
 }
}   

export default InfoZooplankton;